import React from 'react';

export const WateringPlant = props => (
  <svg width="222px" height="162px" viewBox="0 0 222 162" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-1007.000000, -286.000000)">
        <g transform="translate(1007.000000, 286.000000)">
          <path
            d="M167.569827,153.828286 L71.4303682,153.828286 L19.50857,101.847549 C18.8304767,101.168692 18.8304767,100.057914 19.50857,99.3790569 L118.267034,0.508488428 C118.945999,-0.169496143 120.054655,-0.169496143 120.732749,0.508488428 L219.492084,99.3790569 C220.169305,100.057914 220.169305,101.168692 219.492084,101.847549 L167.569827,153.828286 Z"
            fill="#F3F4F6"
            fillRule="nonzero"
          />
          <path
            d="M153.8448,157.3891 C153.8448,159.6991 144.5378,161.5711 133.0578,161.5711 C121.5778,161.5711 112.2718,159.6991 112.2718,157.3891 C112.2718,155.0781 121.5778,153.2061 133.0578,153.2061 C144.5378,153.2061 153.8448,155.0781 153.8448,157.3891"
            fill="#D0D7DA"
          />
          <path
            d="M147.7872,155.935 L118.4512,155.935 C112.6342,155.935 107.8742,151.175 107.8742,145.358 C107.8742,139.54 112.6342,134.781 118.4512,134.781 L147.7872,134.781 C153.6042,134.781 158.3642,139.54 158.3642,145.358 C158.3642,151.175 153.6042,155.935 147.7872,155.935"
            fill="#FFFFFF"
          />
          <path
            d="M147.7872,155.935 L118.4512,155.935 C112.6342,155.935 107.8742,151.175 107.8742,145.358 C107.8742,139.54 112.6342,134.781 118.4512,134.781 L147.7872,134.781 C153.6042,134.781 158.3642,139.54 158.3642,145.358 C158.3642,151.175 153.6042,155.935 147.7872,155.935 Z"
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M141.7862,141.0863 L110.2712,141.0863"
            stroke="#F2C217"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M155.2056,147.059 C155.2056,151.25 148.4236,153.633 148.4236,153.633 L148.4236,144.071 L155.2056,144.071 L155.2056,147.059 Z"
            fill="#F2F3F3"
          />
          <path
            d="M155.9673,141.0863 L145.4343,141.0863"
            stroke="#F2C217"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M161.794,153.2065 L193.539,153.2065"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M105.7081,153.2065 L51.9521,153.2065"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M41.9517,153.2065 L33.9157,153.2065"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M99.5455,102.601 L99.5455,104.601"
            stroke="#0B9CE5"
            strokeLinecap="round"
          />
          <path
            d="M99.5455,108.601 L99.5455,110.601"
            stroke="#0B9CE5"
            strokeLinecap="round"
          />
          <path
            d="M103.5455,106.601 L101.5455,106.601"
            stroke="#0B9CE5"
            strokeLinecap="round"
          />
          <path
            d="M97.5455,106.601 L95.5455,106.601"
            stroke="#0B9CE5"
            strokeLinecap="round"
          />
          <path
            d="M162.607,86.0951 L162.607,88.0951"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M162.607,92.0951 L162.607,94.0951"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M166.607,90.0951 L164.607,90.0951"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M160.607,90.0951 L158.607,90.0951"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M145.6578,74.5658 C145.6578,75.4038 144.9778,76.0838 144.1398,76.0838 C143.3018,76.0838 142.6218,75.4038 142.6218,74.5658 C142.6218,73.7278 143.3018,73.0478 144.1398,73.0478 C144.9778,73.0478 145.6578,73.7278 145.6578,74.5658"
            fill="#F5C400"
          />
          <path
            d="M171.3746,109.601 C171.3746,110.439 170.6946,111.119 169.8566,111.119 C169.0186,111.119 168.3386,110.439 168.3386,109.601 C168.3386,108.762 169.0186,108.082 169.8566,108.082 C170.6946,108.082 171.3746,108.762 171.3746,109.601"
            fill="#0B9CE5"
          />
          <path
            d="M121.9385,134.351 C120.5985,133.218 119.9525,131.322 120.3225,129.607 C120.6925,127.891 122.0625,126.43 123.7505,125.951 C124.1205,125.846 124.5405,125.759 124.7545,125.44 C125.2235,124.745 124.2775,123.977 123.5085,123.642 C121.0895,122.587 118.6915,121.135 117.3955,118.837 C116.0985,116.539 116.2995,113.232 118.4335,111.679 C120.1935,110.398 122.5845,110.642 124.7405,110.333 C126.3725,110.099 127.9535,109.512 129.3435,108.625 C129.5945,108.466 129.8465,108.289 130.0005,108.035 C130.2545,107.614 130.1875,107.078 130.0685,106.601 C129.8025,105.534 129.3155,104.518 129.1875,103.425 C129.0585,102.333 129.4025,101.072 130.3775,100.563 C132.0015,99.715 133.8755,101.454 135.6965,101.262 C135.8215,99.654 137.1695,98.351 138.6795,97.784 C140.1885,97.215 141.8475,97.238 143.4595,97.267 C144.1445,97.279 144.8825,97.309 145.4225,97.731 C146.0115,98.19 146.2035,98.991 146.2815,99.734 C146.4945,101.75 146.1465,103.824 145.2855,105.661 C144.9925,106.286 144.6705,107.109 145.1685,107.586 C145.3865,107.795 145.7025,107.859 146.0025,107.889 C146.9785,107.986 147.9665,107.825 148.9395,107.934 C149.9145,108.042 150.9465,108.519 151.2945,109.435 C151.6465,110.358 151.1705,111.42 150.4495,112.095 C149.7275,112.77 148.7965,113.164 147.9335,113.644 C146.0005,114.72 144.3455,116.292 143.1715,118.169 C142.7585,118.83 142.3955,119.632 142.6595,120.365 C143.0815,121.536 144.6515,121.642 145.8935,121.739 C147.2045,121.841 148.5645,122.203 149.4995,123.128 C150.4335,124.055 150.7765,125.663 149.9805,126.71 C149.4005,127.473 148.4065,127.767 147.4815,128.016 C146.3675,128.317 145.2535,128.617 144.1395,128.916 C145.9545,129.913 147.0365,132.314 146.6645,134.351"
            fill="#CCD82B"
          />
          <path
            d="M131.5479,133.9819 C131.5479,133.9819 129.6399,114.7679 140.2769,106.9109"
            stroke="#575700"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polygon
            fill="#FFFFFF"
            points="147.116 143.55 155.856 143.55 155.856 141.607 147.116 141.607"
          />
          <path
            d="M98.567,69.3217 C94.653,68.5477 90.563,68.3167 86.388,68.7087"
            stroke="#0B9CE5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M119.8433,80.5229 C115.6613,76.4529 110.6543,73.2549 105.1313,71.1879"
            stroke="#0B9CE5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M124.5045,85.891 C123.5345,84.563 122.4885,83.294 121.3755,82.093"
            stroke="#0B9CE5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M103.4781,76.1703 C98.3131,73.4383 92.4251,71.8913 86.1761,71.8913"
            stroke="#0B9CE5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M120.6568,95.3598 C117.9628,88.5248 113.2958,82.6838 107.3578,78.5388"
            stroke="#0B9CE5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g transform="translate(116.000000, 10.710000)">
            <path
              d="M48.8404,11.3754 C46.4574,9.0784 43.3404,9.5924 43.3404,9.5924 C43.3404,9.5924 44.6244,3.9134 36.1914,1.3294 C27.7584,-1.2536 24.0924,4.1994 24.0924,4.1994 C19.5094,0.7564 16.0264,4.7734 14.3774,7.3564 C12.7274,9.9394 11.4444,12.5224 6.1274,13.0974 C0.8114,13.6714 0.2614,18.5504 0.2614,18.5504 L57.4704,18.5504"
              fill="#FFFFFF"
            />
            <path
              d="M48.8404,11.3754 C46.4574,9.0784 43.3404,9.5924 43.3404,9.5924 C43.3404,9.5924 44.6244,3.9134 36.1914,1.3294 C27.7584,-1.2536 24.0924,4.1994 24.0924,4.1994 C19.5094,0.7564 16.0264,4.7734 14.3774,7.3564 C12.7274,9.9394 11.4444,12.5224 6.1274,13.0974 C0.8114,13.6714 0.2614,18.5504 0.2614,18.5504 L57.4704,18.5504"
              stroke="#DCE4E7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M216.3442,52.3002 C214.9542,50.9602 213.1362,51.2602 213.1362,51.2602 C213.1362,51.2602 213.8842,47.9462 208.9652,46.4392 C204.0452,44.9322 201.9062,48.1132 201.9062,48.1132 C199.2322,46.1042 197.1992,48.4482 196.2372,49.9552 C195.2742,51.4622 194.5262,52.9692 191.4242,53.3042 C188.3222,53.6392 188.0012,56.4862 188.0012,56.4862 L221.3802,56.4862"
            stroke="#DCE4E7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M169.857,20.0356 C171.372,17.7936 173.937,16.3186 176.847,16.3186 C181.502,16.3186 185.276,20.0936 185.276,24.7486 C185.276,29.4036 181.502,33.1786 176.847,33.1786 C175.101,33.1786 173.479,32.6466 172.134,31.7386"
            stroke="#F5C400"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M166.4732,16.9272 C168.8382,13.8122 172.5812,11.8002 176.7932,11.8002 C183.9452,11.8002 189.7422,17.5972 189.7422,24.7482 C189.7422,31.9002 183.9452,37.6972 176.7932,37.6972 C172.8612,37.6972 169.3372,35.9442 166.9632,33.1762"
            stroke="#F5C400"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M176.7281,4.1186 L176.7281,8.8566"
            stroke="#F5C400"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M176.7281,40.9027 L176.7281,45.6407"
            stroke="#F5C400"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M192.9165,24.3998 L197.5395,24.3998"
            stroke="#F5C400"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M161.9317,9.9194 L165.2827,13.2704"
            stroke="#F5C400"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M187.9419,35.9301 L191.2929,39.2811"
            stroke="#F5C400"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M187.7202,12.8139 L190.9892,9.5449"
            stroke="#F5C400"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M160.9981,39.5365 L164.2671,36.2665"
            stroke="#F5C400"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M131.6085,126.3012 C133.1805,124.1332 135.5745,122.5772 138.1935,122.0202"
            stroke="#575700"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M147.4815,128.016 C146.3675,128.317 145.2535,128.617 144.1395,128.916 C145.9545,129.912 147.0705,132.088 146.6985,134.124"
            stroke="#575700"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M129.1871,103.4252 C129.0591,102.3332 129.4021,101.0712 130.3781,100.5632 C132.0011,99.7152 133.8751,101.4532 135.6961,101.2622 C135.8221,99.6542 137.1691,98.3512 138.6791,97.7832 C140.1891,97.2152 141.8471,97.2382 143.4601,97.2672 C144.1451,97.2792 144.8831,97.3092 145.4231,97.7312 C146.0121,98.1902 146.2041,98.9902 146.2821,99.7342 C146.4951,101.7502 146.1461,103.8232 145.2861,105.6602 C144.9931,106.2852 144.6701,107.1092 145.1681,107.5862 C145.3861,107.7952 145.7031,107.8592 146.0031,107.8892 C146.9781,107.9862 147.9661,107.8242 148.9401,107.9342 C149.9141,108.0422 150.9471,108.5192 151.2951,109.4352 C151.6461,110.3582 151.1701,111.4202 150.4491,112.0952 C149.7281,112.7702 148.7961,113.1632 147.9341,113.6442 C146.0001,114.7202 144.3451,116.2922 143.1721,118.1692 C142.7591,118.8292 142.3951,119.6322 142.6591,120.3642 C143.0821,121.5352 144.6521,121.6422 145.8931,121.7382 C147.2051,121.8412 148.5651,122.2022 149.4991,123.1282 C150.4341,124.0552 150.7761,125.6622 149.9801,126.7102"
            stroke="#575700"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M117.3951,118.8373 C116.0981,116.5383 116.2991,113.2323 118.4331,111.6793 C120.1941,110.3983 122.5841,110.6423 124.7401,110.3333 C126.3731,110.0993 127.9541,109.5123 129.3441,108.6253 C129.5941,108.4663 129.8461,108.2883 130.0001,108.0343 C130.2541,107.6133 130.1871,107.0773 130.0681,106.6013"
            stroke="#575700"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M121.647,134.0785 C120.307,132.9455 119.952,131.3215 120.322,129.6065 C120.692,127.8915 122.062,126.4305 123.75,125.9505 C124.12,125.8465 124.541,125.7595 124.755,125.4395 C125.223,124.7445 124.278,123.9765 123.509,123.6415"
            stroke="#575700"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.1539,34.9584 C10.1629,41.3624 11.6259,58.8494 14.3389,60.5384 C20.7429,64.5294 33.3929,55.8384 37.3839,49.4344 C41.3749,43.0284 39.4119,34.5714 33.0079,30.5804 C26.6029,26.5894 18.1449,28.5534 14.1539,34.9584 Z M17.7099,26.3164 C23.0859,23.5994 29.7149,23.6674 35.1899,27.0794 C43.5249,32.2724 46.0799,43.2804 40.8849,51.6164 C35.6909,59.9514 20.4909,69.2344 12.1559,64.0404 C7.2609,60.9904 5.4579,41.1114 10.6529,32.7754 L17.7099,26.3164 Z"
            stroke="#7350A0"
            strokeLinecap="round"
          />
          <polygon
            fill="#FFFFFF"
            points="0.6143 73.6449 35.5133 95.3919 57.5713 55.9959 26.2633 36.4859"
          />
          <polygon
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="0.6143 73.6449 35.5133 95.3919 57.5713 55.9959 26.2633 36.4859"
          />
          <polygon
            fill="#FFFFFF"
            points="47.9302 73.0873 73.4782 68.3273 75.0532 73.3123 40.0052 87.2353"
          />
          <polygon
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="47.9302 73.0873 73.4782 68.3273 75.0532 73.3123 40.0052 87.2353"
          />
          <polygon
            fill="#F2F3F3"
            points="3.2906 72.6557 11.0546 77.4947 32.1276 43.6767 26.0616 39.8967"
          />
          <path
            d="M12.1578,73.6254 L4.8718,69.0844"
            stroke="#D62793"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M37.439,89.3793 L17.706,77.0823"
            stroke="#D62793"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M73.2862,67.808 L75.3632,73.702 L78.7502,74.673 C78.7502,74.673 80.6142,72.342 79.4532,69.044 C78.2902,65.746 75.5892,64.831 75.5892,64.831 L73.2862,67.808 Z"
            fill="#FFFFFF"
          />
          <path
            d="M73.2862,67.808 L75.3632,73.702 L78.7502,74.673 C78.7502,74.673 80.6142,72.342 79.4532,69.044 C78.2902,65.746 75.5892,64.831 75.5892,64.831 L73.2862,67.808 Z"
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polygon
            fill="#FFFFFF"
            points="5.398 68.7709 15.846 75.2819 16.805 73.7439 6.356 67.2329"
          />
          <polygon
            fill="#FFFFFF"
            points="23.1583 37.4682 58.0573 59.2162 59.9863 56.1212 25.0873 34.3732"
          />
          <polygon
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="23.1583 37.4682 58.0573 59.2162 59.9863 56.1212 25.0873 34.3732"
          />
        </g>
      </g>
    </g>
  </svg>
);
